export default __webpack_public_path__ + "static/media/img-0233-australia-full-face.62564139.png";